/* @flow */

import getInputPorId from '../../utils/get-input-por-id';
import * as mascaras from '../../utils/mascaras';
import { type Contato } from '../../usuario/types';

const preencherFormContatos = (contatos: Contato[]) => {
    contatos.forEach((contato, key) => {
        mascaras.mascaraTelefone(document.querySelector('[type="tel"]'));
        getInputPorId(`id-${key}`).value = String(contato.id);
        document.getElementById(`nome-contato-${key}`).value = contato.nome || '';
        getInputPorId(`telefone-contato-${key}`).value = String(contato.ddd + contato.numero);
    });
};

export default preencherFormContatos;
